/**
 * Count input with increment (+) and decrement (-) buttons
 */

export default (() => {
  const countInputs = document.querySelectorAll('.count-input')

  if (countInputs.length === 0)
    return;

  const parseNumber = (value, fallback) =>
  {
    const parsedValue = parseFloat(value)

    return Number.isFinite(parsedValue)
      ? parsedValue
      : fallback
  }

  const getDecimalPlaces = (value) =>
  {
    if (!Number.isFinite(value))
      return 0

    const normalizedValue = value.toString().toLowerCase()

    if (!normalizedValue.includes('e'))
      return (normalizedValue.split('.')[1] || '').length

    const parts = normalizedValue.split('e')
    const mantissa = parts[0]
    const exponent = parseInt(parts[1], 10)
    const mantissaDecimals = (mantissa.split('.')[1] || '').length

    return Math.max(0, mantissaDecimals - exponent)
  }

  const getPrecisionFactor = (values) =>
  {
    let decimalPlaces = 0

    values.forEach(value =>
    {
      decimalPlaces = Math.max(decimalPlaces, getDecimalPlaces(value))
    })

    return 10 ** decimalPlaces
  }

  const handleIncrement = (event) =>
  {
    const input = event.currentTarget.parentNode.querySelector('.form-control');
    const currentValue = parseNumber(input.value, 0)
    const maxValue = parseNumber(input.getAttribute('max'), Infinity)
    const multiplyValue = parseNumber(input.dataset.multiply, 1)
    const factor = getPrecisionFactor([currentValue, multiplyValue, maxValue])

    if (currentValue < maxValue)
    {
      let nextValue = Math.round(currentValue * factor) + Math.round(multiplyValue * factor)
      nextValue = Math.min(nextValue, Math.round(maxValue * factor))
      input.value = nextValue / factor

      if (input.attributes.value)
        input.attributes.value.value = input.value;

      input.dispatchEvent(new Event("change", { bubbles: true }));

      updateButtonStates(input)
    }
  }

  const handleDecrement = (event) =>
  {
    const input = event.currentTarget.parentNode.querySelector('.form-control');
    const currentValue = parseNumber(input.value, 0)
    const minValue = parseNumber(input.getAttribute('min'), 0)
    const multiplyValue = parseNumber(input.dataset.multiply, 1)
    const factor = getPrecisionFactor([currentValue, multiplyValue, minValue])

    if (currentValue > minValue)
    {
      let nextValue = Math.round(currentValue * factor) - Math.round(multiplyValue * factor)
      nextValue = Math.max(nextValue, Math.round(minValue * factor))
      input.value = nextValue / factor

      if (input.attributes.value)
        input.attributes.value.value = input.value;

      input.dispatchEvent(new Event("change", { bubbles: true }));

      updateButtonStates(input)
    }
  }

  const updateButtonStates = (input) =>
  {
    const decrementBtn = input.parentNode.querySelector('[data-decrement]')
    const incrementBtn = input.parentNode.querySelector('[data-increment]')
    const minValue = parseFloat(input.getAttribute('min')) || 0
    const maxValue = parseFloat(input.getAttribute('max')) || Infinity

    if (decrementBtn)
      decrementBtn.disabled = input.value <= minValue;

    if (incrementBtn)
      incrementBtn.disabled = input.value >= maxValue

    const parent = input.closest('.count-input');

    if (!parent.classList.contains('count-input-collapsible'))
      return

    const inputValue = incrementBtn.querySelector('[data-count-input-value]')

    if (input.value > 0) {
      parent.classList.remove('collapsed')
      if (inputValue) {
        inputValue.textContent = input.value
      }
    } else {
      parent.classList.add('collapsed')
      if (inputValue) {
        inputValue.textContent = ''
      }
    }
  }

  countInputs.forEach((component) => {
    const incrementBtn = component.querySelector('[data-increment]')
    const decrementBtn = component.querySelector('[data-decrement]')
    const input = component.querySelector('.form-control')

    if (incrementBtn)
      incrementBtn.addEventListener('click', handleIncrement);

    if (decrementBtn)
      decrementBtn.addEventListener('click', handleDecrement)

    updateButtonStates(input)
  })

  document.addEventListener("onElementAdded", event =>
  {
    const countElements = document.querySelectorAll('.count-input');

    if (!countElements || countElements.length == 0)
      return;

    countElements.forEach((component) =>
    {
      const incrementBtn = component.querySelector('[data-increment]')
      const decrementBtn = component.querySelector('[data-decrement]')
      const input = component.querySelector('.form-control')

      if (incrementBtn)
        incrementBtn.addEventListener('click', handleIncrement);

      if (decrementBtn)
        decrementBtn.addEventListener('click', handleDecrement);

      updateButtonStates(input)
    })
  })
})()
